import { render, staticRenderFns } from "./categoryArticle.vue?vue&type=template&id=78dde90b&scoped=true"
import script from "./categoryArticle.vue?vue&type=script&lang=js"
export * from "./categoryArticle.vue?vue&type=script&lang=js"
import style0 from "./categoryArticle.vue?vue&type=style&index=0&id=78dde90b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dde90b",
  null
  
)

export default component.exports